export default {
	en: {
		translation: {
			camera: {
				capture: "Capture",
				cancel: "Cancel",

				take_pic: "Take a picture and upload it",

				explanation: "Make sure that your camera is connected and that your browser allows camera capture. When ready, click Capture.",

				camera_error: "Failed to access camera",

				retry: "Retry Camera",

				file_name: "Camera_{{time}}",
			},
		},
	},
};
